import { uploadData, getUrl } from "aws-amplify/storage";

export async function s3UploadFile(path: string, file: any): Promise<Blob | null> {
  return s3UploadObjectUrl(path, file.objectURL);
}
export async function s3UploadObjectUrl(path: string, objectURL: string): Promise<Blob | null> {
  try {
    let blob = await fetch(objectURL).then(r => r.blob());
    const result = await uploadData({
      key: path,
      data: blob,
      options: {
        accessLevel: "guest",
        contentType: blob.type,
      },
    }).result;
    return blob;
  } catch (e) {
    return null;
  }
}

export async function s3UploadFileImage(path: string, fileUrl: string): Promise<Blob | null> {
  try {
    let blob = await fetch(fileUrl).then(r => r.blob());

    const result = await uploadData({
      key: path,
      data: blob,
      options: {
        accessLevel: "guest",
        contentType: blob.type,
      },
    }).result;
    return blob;
  } catch (e) {
    return null;
  }
}

export async function s3GetUrl(path: string) {
  try {
    const file = await getUrl({
      key: path,
      options: {
        accessLevel: "guest",
      },
    });
    return file.url.href;
  } catch (e) {
    return "";
  }
}

export function getFileExtension(mimeType: string): string {
  const mimeTypes: { [key: string]: string } = {
    "application/pdf": "pdf",
    "image/jpeg": "jpg",
    "image/png": "png",
    "text/plain": "txt",
    "application/msword": "doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
    // Add more MIME types and their corresponding extensions as needed
  };
  return mimeTypes[mimeType] || "bin";
}

export async function s3GetUrlBase64(path: string): Promise<string> {
  try {
    const file = await s3GetUrl(path);
    const blob = await fetch(file).then(response => response.blob());

    return await new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (e) {
    return "";
  }
}

export async function downloadFile(name: string, path: string) {
  try {
    const file = await s3GetUrl(path);
    await fetch(file)
      .then(response => response.blob())
      .then(blob => {
        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;

        const ext = getFileExtension(blob.type);

        link.setAttribute("download", `${name}.${ext}`);

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode?.removeChild(link);
      });
    return true;
    // return await restOperation.response;
  } catch (e) {
    return false;
  }
}

export async function openFile(name: string, path: string) {
  try {
    const file = await getUrl({
      key: path,
      options: {
        accessLevel: "guest",
      },
    });

    window.open(file.url, "_blank");
    return true;
    // return await restOperation.response;
  } catch (e) {
    return false;
  }
}

export async function getFile(name: string, path: string) {
  try {
    const file = await s3GetUrl(path);
    await fetch(file)
      .then(response => response.blob())
      .then(blob => {
        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;

        const ext = getFileExtension(blob.type);
      });
  } catch (e) {
    return "";
  }
}

export async function getFileBlobS3Proxy(key: string): Promise<Blob | undefined> {
  try {
    const proxyUrl =
      process.env.REACT_APP_ENV === `production`
        ? "https://gytnx4lmohkcqbhwgz3mbvqtla0rgxvi.lambda-url.eu-west-1.on.aws"
        : "https://wrjquoblm6r7cc2whc2dw6k4oq0ydwmm.lambda-url.eu-west-1.on.aws";
    const response = await fetch(`${proxyUrl}/?key=public/${key}`);
    const blob = await response.blob();
    return blob;
  } catch (e) {
    return undefined;
  }
}

export async function getFileBlobUrlS3Proxy(key: string) {
  try {
    const blob = await getFileBlobS3Proxy(key);
    if (!blob) return "";
    return URL.createObjectURL(blob);
  } catch (e) {
    return "";
  }
}
